module.exports = __webpack_public_path__ + "static/img/partner-logo-11.dfdb4233.png";